import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../../services/loading/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoadingService);

  if (
    req.url.includes('/health-check') ||
    req.url.includes('/dashboard/summary') ||
    req.headers.has('x-skip-loader')
  ) {
    return next(req);
  }

  loader.show();
  return next(req).pipe(finalize(() => loader.hide()));
};